import React from 'react';
import Resultat from '../Models/Resultat';
import DBostedValg from '../Utilities/D-BostedValg';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import VeilederHounDto from '../Models/VeilederHounDto';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { VeilederHounAppState } from '../Store';
import { connect } from 'react-redux';
import { toggleFordeling } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';
import { ResultatH } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';

interface HResultatOwnProps {
    verdiD: string | undefined;
    resultat: Resultat;
}

type HResultatProps = HResultatOwnProps & MapStateToProps & MapDispatchToProps & {};

class HResultatComponent extends React.PureComponent<HResultatProps> {
    constructor(props: HResultatProps) {
        super(props);
        this.onStipendOgLanClick = this.onStipendOgLanClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleFordeling();
    }

    borBorte = (bosituasjon: string | undefined): boolean => {
        return bosituasjon === DBostedValg.d2_borte;
    };

    onStipendOgLanClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleFordeling();
    }

    render(): JSX.Element {
        const { resultat, verdiD, visFordeling, epiContext } = this.props;

        const { locale, valuta } = this.props.epiContext;

        return (
            <div id={ResultatH} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--pinegreen">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'tittelStipend')}
                        </h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <div className="c-veileder__underresultat-tekst">
                            <span>{tilPengerFormat(resultat.stipend, locale)}</span>
                            <span className="c-veileder__tekst--postfix">&nbsp;{valuta}</span>
                        </div>
                        {this.borBorte(verdiD) ? (
                            <p className="c-veileder__tekst">{contentResolver(epiContext, 'undertittelStipend')}</p>
                        ) : null}
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'tittelLan')}
                        </h3>
                    </div>

                    <div className="c-veileder__content c-veileder__content--with-space-desktop c-veileder__content--indented ">
                        <div className="c-veileder__underresultat-tekst">
                            <span>{tilPengerFormat(resultat.lan, locale)}</span>
                            <span className="c-veileder__tekst--postfix">&nbsp;{valuta}</span>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--bunnlenke">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onStipendOgLanClick}>
                            {contentResolver(epiContext, 'lenketekstStipendOgLan')}
                        </button>
                        <ModalCompontent
                            isOpen={visFordeling}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'modalStipendOgLanAriaLabel')}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalStipendOgLanTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalStipendOgLanContent', 2)}
                            />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederHounDto>;
    visFordeling: boolean;
}

interface MapDispatchToProps {
    toggleFordeling: typeof toggleFordeling;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederHounAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visFordeling: state.valg.visFordeling,
        };
    },
    { toggleFordeling, updateZIndex },
)(HResultatComponent);
